import React from 'react';
import { motion } from 'framer-motion';
import { Trans } from 'react-i18next';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { FaInstagram, FaYoutube, FaFacebook } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { getLogoUrl } from '../utils/getLogoUrl';

const Footer: React.FC = () => (
  <footer className="bg-secondary-light dark:bg-secondary-dark py-16">
    <div className="container mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Company Info */}
        <div className="space-y-4">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="inline-block"
          >
            <img 
              src={getLogoUrl()} 
              alt="AgriPuente" 
              className="h-16 w-auto dark:invert" 
            />
          </motion.div>
          <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
            <Trans>footer.description</Trans>
          </p>
        </div>
        {/* Contact Info */}
        <div className="space-y-4">
          <h3 className="font-bold text-lg mb-4">
            <Trans>footer.contact</Trans>
          </h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3 text-gray-600 dark:text-gray-400">
              <EnvelopeIcon className="h-5 w-5" />
              <a href="mailto:info@agripuente.com" className="hover:text-accent transition-colors">
                info@agripuente.com
              </a>
            </div>
          </div>
        </div>
        {/* Social Links */}
        <div className="space-y-4">
          <h3 className="font-bold text-lg mb-4">
            <Trans>footer.social</Trans>
          </h3>
          <div className="flex space-x-6">
            <motion.a
              href="https://twitter.com/agripuente"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-accent transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaXTwitter className="h-6 w-6" />
            </motion.a>
            <motion.a
              href="https://instagram.com/agripuente"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-accent transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaInstagram className="h-6 w-6" />
            </motion.a>
            <motion.a
              href="https://youtube.com/@agripuente"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-accent transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaYoutube className="h-6 w-6" />
            </motion.a>
            <motion.a
              href="https://facebook.com/agripuente"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 dark:text-gray-400 hover:text-accent transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaFacebook className="h-6 w-6" />
            </motion.a>
          </div>
        </div>
      </div>
      {/* Copyright */}
      <div className="border-t border-gray-200 dark:border-gray-800 mt-12 pt-8 text-center text-gray-600 dark:text-gray-400">
        <p className="text-sm">
          &copy; {new Date().getFullYear()} AgriPuente. <Trans>footer.rights</Trans>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
